import { render } from "./deposit_log.vue?vue&type=template&id=79b8d351&scoped=true"
import script from "./deposit_log.vue?vue&type=script&lang=js"
export * from "./deposit_log.vue?vue&type=script&lang=js"

import "./deposit_log.vue?vue&type=style&index=0&id=79b8d351&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b8d351"]])

export default __exports__